import { getGoalsAndInterventionsByCertificationPeriodOptions, type FullOrderViewModel } from '@generated';
import { OrderItems } from '~/features/orders/OrderItems';
import { useSuspenseQuery } from '@tanstack/react-query';
import { GoalAndInterventionsWizardFormModal } from '../wizard/GoalAndInterventionsWizardFormModal';
import { useFullOrder } from '~/features/orders/orders/FullOrderContext';
import { GoalOrderRow } from '../goals/GoalOrderRow';

export function hasGoalsAndInterventionsOrders(fullOrder: FullOrderViewModel) {
	return fullOrder.goals.length > 0 || fullOrder.interventions.length > 0;
}

export function GoalsAndInterventionOrders() {
	const { fullOrder } = useFullOrder();
	const { data: goalsAndInterventions } = useSuspenseQuery(getGoalsAndInterventionsByCertificationPeriodOptions(fullOrder.certificationPeriodId));
	const orderInterventionIds = fullOrder.interventions.map(x => x.id);
	const orderGoalIds = fullOrder.goals.map(x => x.id);
	const allGoals = [
		...fullOrder.goals,
		...goalsAndInterventions.goals.filter(x => !orderGoalIds.includes(x.id) && x.interventionIds.some(id => orderInterventionIds.includes(id)))
	];

	return (
		<OrderItems
			title="Goals and Interventions"
			items={allGoals.map(goal => (
				<GoalOrderRow key={goal.id} goal={goal} />
			))}
			sectionButtonProps={{
				label: 'Add Goal/Intervention',
				useSuspense: true,
				actionType: 'add',
				renderModal: closeModal => <GoalAndInterventionsWizardFormModal fullOrder={fullOrder} closeModal={closeModal} />
			}}
		/>
	);
}
